export interface AOModuleEnvInterface {

  production: boolean;

  faunadb: {
    secret: string
  };

  firebase: {
    name: string,
    configs: {
      apiKey: string,
      authDomain: string,
      databaseURL: string,
      projectId: string,
      storageBucket: string,
      messagingSenderId: string,
      appId: string,
      measurementId: string
    }
  };

}
